import { createRoot } from 'react-dom/client'

// ── Design system tokens (CSS variables + @font-face) ──────────────
import './sg/tokens.css'

// ── Design handoff modules, imported in DEPENDENCY ORDER ───────────
// Each file is a side-effecting module that registers itself on window.SG*.
// Order matters: icons → kit → leaf components → screens → app shell.
import './sg/icons.jsx'        // window.SGIcons
import './sg/kit.jsx'          // window.SGKit  (needs SGIcons)
import './sg/SGLive.jsx'       // window.SGLive (shared live-data layer + hooks)
import './sg/SGSidebar.jsx'    // window.SGSidebar
import './sg/SGTopBar.jsx'     // window.SGTopBar
import './sg/GeoVisibility.jsx'// window.SGGeoVisibility
import './sg/SGDashboard.jsx'  // window.SGDashboard
import './sg/SGSiteAudit.jsx'  // window.SGSiteAudit
import './sg/SGKeywords.jsx'   // window.SGKeywords
import './sg/SGContent.jsx'    // window.SGContent (AI Content Studio — article + social campaign)
import './sg/SGRankTracking.jsx' // window.SGRankTracking
import './sg/SGCompetitors.jsx'  // window.SGCompetitors
import './sg/SGBacklinks.jsx'    // window.SGBacklinks
import './sg/SGReports.jsx'      // window.SGReports (+ ReportViewer)
import './sg/SGSearchPerformance.jsx' // window.SGSearchPerformance (LIVE — real GSC data)
import './sg/SGListings.jsx'    // window.SGListings (Local Listings / citations)
import './sg/SGAgentReadiness.jsx' // window.SGAgentReadiness (machine discoverability)
import './sg/SGConnections.jsx' // window.SGConnections (LIVE — calls the deployed API)
import './sg/SGVideo.jsx'      // window.SGVideo (YouTube/video SEO, vidIQ-style)
import './sg/SGAdmin.jsx'      // window.SGAdmin (master-only client management / discounts)
import './sg/SGAuth.jsx'       // window.SGAuth (separate login screen)
import './sg/SGApp.jsx'        // window.SGApp (composes the above)

// `React` is auto-injected per file by vite.config jsxInject.
// Auth gate: show a branded spinner while checking, the login screen when the
// session is missing/expired, else the app.
function Root() {
  const { state, setAuthed } = window.SGLive.useAuthGate();
  if (state === 'checking') {
    return React.createElement('div', {
      style: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--sg-page)' },
    }, React.createElement('div', {
      style: { width: 34, height: 34, border: '3px solid var(--sg-border)', borderTopColor: 'var(--sg-blue-600)', borderRadius: '50%', animation: 'sg-spin 0.8s linear infinite' },
    }));
  }
  if (state === 'needsLogin') return React.createElement(window.SGAuth, { onAuthed: setAuthed });
  if (state === 'mustChange') return React.createElement(window.SGChangePassword, { onDone: setAuthed });
  return React.createElement(window.SGApp);
}

createRoot(document.getElementById('root')).render(
  React.createElement(Root)
)
